import { PipelineStepper, PIPELINE_STEPS } from './PipelineStepper'
import { TaxonomyRun } from '@/hooks/useTaxonomyRun'

interface RunningStateProps {
  run: TaxonomyRun
}

export function RunningState({ run }: RunningStateProps) {
  // Find the currently active step label for the detail line
  const activeStep = PIPELINE_STEPS.find((step, idx) => {
    const prevThreshold = idx === 0 ? 0 : PIPELINE_STEPS[idx - 1].threshold
    return run.progress >= prevThreshold && run.progress < step.threshold
  })

  return (
    <div className="w-full">
      {/* Stepper — fixed 60px */}
      <PipelineStepper progress={run.progress} status="running" />

      {/* Active step detail */}
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-500">
          <span className="font-medium text-blue-600">
            {activeStep?.label ?? 'Processing…'}
          </span>
          {activeStep && <span className="text-gray-400"> — {activeStep.full}</span>}
        </p>
        <p className="text-xs text-gray-400 mt-1">
          {run.progress}% complete · {run.total_chunks_processed} chunks
        </p>
      </div>
    </div>
  )
}
